export default __webpack_public_path__ + "locales/vi/SalesDepartmentRequestDialog.json?hash=0c2391ab0998b12df27dd2ff7510ca45";